<section>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="user-dashboard-info-box mb-0">
            <div class="section-title-02 mb-4">
              <h4>Buy Our Plans and Packages</h4>
            </div>
            <div class="row">
            <div class="col-md-6 text-center">
              <div class="pricing-plan">
                <div class="pricing-price">
                  <span><sup>$</sup><strong>10</strong>/day</span>
                  <h5 class="pricing-title">Sponsor Jobs</h5>
                </div>
                <ul class="list-unstyled pricing-list">
                  <li>Premium placement</li>
                  <li>PPC on your Job</li>
                  <li>Reach more candidates</li>
                  <li>Desktop, mobile and Job Alerts</li>
                </ul>
                <a class="btn btn-outline" href="#">Get Started</a>
              </div>
            </div>
            <div class="col-md-6 text-center">
              <div class="pricing-plan active">
                <div class="pricing-price">
                  <span><sup>$</sup><strong>299</strong>/month</span>
                  <h5 class="pricing-title">Premium Plan</h5>
                </div>
                <ul class="list-unstyled pricing-list">
                  <li>Job ad live for six-weeks</li>
                  <li>50 Feature Jobs </li>
                  <li>Premium placement </li>
                  <li>Desktop, mobile and Job Alerts</li>
                </ul>
                <a class="btn btn-outline" href="#">Select Plan</a>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </section>